export const colors = {
  bg:           '#0F1117',
  bgSurface:    '#161B27',
  bgCard:       '#1C2333',
  bgCardHover:  '#212840',
  bgInput:      '#131825',
  border:       '#2A3250',
  borderMid:    '#323C5C',
  borderFocus:  '#5B6EE8',
  text:         '#E8EAF6',
  textMuted:    '#8892B0',
  textLight:    '#64748B',
  textHint:     '#3D4A6B',
  primary:      '#5B6EE8',
  primaryHover: '#7080F0',
  primaryGlow:  'rgba(91,110,232,0.25)',
  danger:       '#F87171',
  dangerBg:     'rgba(248,113,113,0.12)',
  dangerBorder: 'rgba(248,113,113,0.35)',
  dangerHover:  '#EF4444',
  success:      '#34D399',
  successBg:    'rgba(52,211,153,0.12)',
  infoBg:       'rgba(96,165,250,0.15)',
  infoText:     '#93C5FD',
  greenBg:      'rgba(52,211,153,0.15)',
  greenText:    '#6EE7B7',
  amberBg:      'rgba(251,191,36,0.15)',
  amberText:    '#FCD34D',
  purpleBg:     'rgba(167,139,250,0.15)',
  purpleText:   '#C4B5FD',
  sidebarBg:    '#0B0F1C',
  sidebarBorder:'#1E2640',
  navActive:    'rgba(91,110,232,0.2)',
  navActiveText:'#A5B4FC',
  white:        '#FFFFFF',
};

export const radius = { sm: 6, md: 10, lg: 14, xl: 18, xxl: 24 };

export const shadows = {
  card:    '0 4px 24px rgba(0,0,0,0.4), 0 1px 4px rgba(0,0,0,0.3)',
  modal:   '0 20px 60px rgba(0,0,0,0.7), 0 4px 20px rgba(0,0,0,0.5)',
  primary: '0 4px 20px rgba(91,110,232,0.4)',
  input:   '0 0 0 3px rgba(91,110,232,0.2)',
};

export const btn = {
  base: {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap',
    lineHeight: 1, transition: 'all 0.2s ease', border: 'none', fontWeight: 500,
  },
  ghost: {
    padding: '9px 16px', border: `1px solid ${colors.border}`,
    background: 'transparent', color: colors.textMuted,
    borderRadius: radius.md, fontSize: 14,
  },
  ghostSm: {
    padding: '6px 12px', border: `1px solid ${colors.border}`,
    background: 'transparent', color: colors.textMuted,
    borderRadius: radius.sm, fontSize: 12,
  },
  primary: {
    padding: '10px 20px',
    background: `linear-gradient(135deg, ${colors.primary}, ${colors.primaryHover})`,
    color: colors.white, border: 'none', fontWeight: 600,
    letterSpacing: '-0.2px', borderRadius: radius.md, fontSize: 14,
    boxShadow: shadows.primary,
  },
  danger: {
    padding: '9px 18px', background: colors.dangerHover,
    color: colors.white, border: 'none', fontWeight: 600,
    borderRadius: radius.md, fontSize: 14,
  },
  outlineDanger: {
    padding: '6px 12px', border: `1px solid ${colors.dangerBorder}`,
    background: colors.dangerBg, color: colors.danger,
    borderRadius: radius.sm, fontSize: 12,
  },
};

export const field = {
  wrapper:  { marginBottom: 16 },
  label: {
    display: 'block', fontSize: 11, fontWeight: 700,
    color: colors.textMuted, marginBottom: 6,
    textTransform: 'uppercase', letterSpacing: '0.8px',
  },
  input: {
    width: '100%', padding: '10px 14px',
    border: `1px solid ${colors.border}`, borderRadius: radius.md,
    background: colors.bgInput, color: colors.text,
    fontSize: 14, fontFamily: 'inherit', outline: 'none',
    boxSizing: 'border-box', transition: 'all 0.2s ease',
  },
  textarea: {
    width: '100%', padding: '10px 14px',
    border: `1px solid ${colors.border}`, borderRadius: radius.md,
    background: colors.bgInput, color: colors.text,
    fontSize: 14, fontFamily: 'inherit', outline: 'none',
    resize: 'vertical', minHeight: 80,
    boxSizing: 'border-box', transition: 'all 0.2s ease',
  },
  hint: { fontSize: 11, color: colors.textHint, marginTop: 4 },
  row:  { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 },
  error: {
    background: colors.dangerBg, color: colors.danger,
    border: `1px solid ${colors.dangerBorder}`, borderRadius: radius.md,
    padding: '10px 14px', fontSize: 13, marginBottom: 14,
  },
};

export const modal = {
  overlay: {
    position: 'fixed', inset: 0,
    background: 'rgba(0,0,0,0.75)',
    backdropFilter: 'blur(4px)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 200, padding: '1rem',
  },
  box: {
    background: colors.bgCard, borderRadius: radius.xl,
    border: `1px solid ${colors.border}`, boxShadow: shadows.modal,
    width: '100%', maxWidth: 580, maxHeight: '92vh', overflowY: 'auto', padding: '2rem',
  },
  title: { fontSize: 18, fontWeight: 700, marginBottom: '1.5rem', letterSpacing: '-0.4px', color: colors.text },
  footer: {
    display: 'flex', justifyContent: 'flex-end', gap: 10,
    marginTop: '1.5rem', borderTop: `1px solid ${colors.border}`, paddingTop: '1.25rem',
  },
  confirmBox: {
    background: colors.bgCard, borderRadius: radius.xl,
    border: `1px solid ${colors.border}`, boxShadow: shadows.modal,
    padding: '2rem', maxWidth: 400, width: '100%',
  },
};
